export default __webpack_public_path__ + "static/media/arrow-btn-left.367182a7.svg";